export const renderNode = (node, arg) => {
    if (node && typeof node === 'function') {
        return node(arg);
    }

    return node || null;
};
